<script>
    import { fly } from 'svelte/transition';
    import { onMount } from 'svelte';

    let index = 0;
    let currentImageIndex = 0;

    function handleNextProject() {
        if (index < 3) {
            index++;
        } else {
            index = 0;
        }
    }

    function handlePrevProject() {
        if (index > 0) {
            index--;
        } else {
            index = 3;
        }
    }

    function nextImage() {
        const images = document.querySelectorAll(`.project-${index} .project-img`);
        currentImageIndex = (currentImageIndex + 1) % images.length;
        updateImageVisibility(images);
    }

    function prevImage() {
        const images = document.querySelectorAll(`.project-${index} .project-img`);
        currentImageIndex = (currentImageIndex - 1 + images.length) % images.length;
        updateImageVisibility(images);
    }

    function updateImageVisibility(images) {
        images.forEach((img, idx) => {
            img.style.display = idx === currentImageIndex ? 'block' : 'none';
        });
    }

    onMount(() => {
        const images = document.querySelectorAll(`.project-${index} .project-img`);
        updateImageVisibility(images);
    });

</script>

<div class="container flex flex-col h-full text-left mx-auto my-0">
    <div class="shrink-0 grow-0 basis-11/12 px-4 pb-10 overflow-hidden flex items-end md:items-center">
        {#if index === 0}
            <div in:fly={{duration:500,delay:500,x:300}} out:fly={{duration:500,delay:0,x:-300}} class="grid grid-cols-12 project-0">
                <div class="lg:col-span-4 col-span-12 h-full text-left flex flex-col justify-center order-1 lg:order-none">
                    <a target="_blank" class="text-4xl lg:text-5xl project-title py-4 lg:pb-10 lg:pt-0">PlaylistMix</a>
                    <p class="project-description lg:text-base text-sm pb-8">Originating from a passion for music discovery, I built PlaylistMix to tap into Spotify's API to allow users to generate custom playlists from a set of criteria. The application is built on React, with Tailwind as it's style framework. The project is deployed on Cloudflare Pages for a rapid, low-cost and serverless hosting solution.<br><br>
                        The branding, app design and all marketing was done by myself, as well as writing the code and deploying to CDN.</p>
                    <div class="tags-container"><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">React</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">Javascript</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">Tailwind</span></div>
                </div>
                <div class="lg:col-span-8 col-span-12 flex flex-col lg:content-end content-center flex-wrap img-container mb-12 lg:mb-0">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/PlaylistMix-Portfolio-1.png" alt="PlaylistMix Image 1">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/PlaylistMix-Portfolio-2.png" alt="PlaylistMix Image 2" style="display: none;">
                    <h5 class="text-2xl font-thin w-full text-center img-navigation"><span on:click={prevImage} class="cursor-pointer">←</span> | <span on:click={nextImage} class="cursor-pointer">→</span></h5>
                </div>
            </div>
        {/if}
        {#if index === 1}
            <div in:fly={{duration:500,delay:500,x:300}} out:fly={{duration:500,delay:0,x:-300}} class="grid grid-cols-12 project-1">
                <div class="lg:col-span-4 col-span-12 h-full text-left flex flex-col justify-center order-1 lg:order-none">
                    <a target="_blank" class="text-4xl lg:text-5xl project-title py-4 lg:pb-10 lg:pt-0" href="https://shoefit.uk/">ShoeFit Fitting Assistant</a>
                    <p class="project-description lg:text-base text-sm pb-8">Worked alongside DCS Digital to build a custom WordPress plugin using JavaScript. The plugin takes foot measurements and other podiatry information from the user and returns not only their correct shoe size in each sold brand, but also filters the online store to only show compatible products. DCS Digital handled the back-end and designed the UI, while I built the front end solo. I used Javascript and jQuery for the functionality, plus PHP to manage the integration with WordPress.</p>
                    <div class="tags-container"><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">Javascript</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">jQuery</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">WordPress</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">PHP</span></div>
                </div>
                <div class="lg:col-span-8 col-span-12 flex flex-col lg:content-end content-center flex-wrap img-container items-end md:items-center mb-12 lg:mb-0">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/ShoeFitFinal1.png">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/ShoeFitFinal2.png" style="display: none;">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/ShoeFitFinal3.png" style="display: none;">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/ShoeFitFinal3half.png" style="display: none;">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/ShoeFitFinal4.png" style="display: none;">
                    <h5 class="text-2xl font-thin w-full text-center img-navigation">
                        <span on:click={prevImage} class="cursor-pointer">←</span> | 
                        <span on:click={nextImage} class="cursor-pointer">→</span>
                    </h5>
                </div>
            </div>
        {/if}
        {#if index === 2}
            <div in:fly={{duration:500,delay:500,x:300}} out:fly={{duration:500,delay:0,x:-300}} class="grid grid-cols-12 project-2">
                <div class="lg:col-span-4 col-span-12 h-full text-left flex flex-col justify-center order-1 lg:order-none">
                    <a target="_blank" class="text-4xl lg:text-5xl project-title py-4 lg:pb-10 lg:pt-0" href="https://www.dcsdigital.co.uk/airtowoo/">AirToWoo Web App</a>
                    <p class="project-description lg:text-base text-sm pb-8">SaaS Web application built primarily with JavaScript which connects AirTable with WooCommerce via API. This tool allows users to manage their WooCommerce products via an AirTable spreadsheet, and instantly save changes. I was tasked with writing all of the JavaScript which would send and receive webbooks, transform data, intelligently manage images and taxonomies, and much more.</p>
                    <div class="tags-container"><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">JavaScript</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">WordPress</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">AirTable</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">SaaS</span></div>
                </div>
                <div class="lg:col-span-8 col-span-12 flex flex-col lg:content-end content-center flex-wrap img-container items-end md:items-center">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/AirToWoo-Portfolio-1.png">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/AirToWoo-Portfolio-2.png" style="display: none;">
                    <h5 class="text-2xl font-thin w-full text-center img-navigation">
                        <span on:click={prevImage} class="cursor-pointer">←</span> | 
                        <span on:click={nextImage} class="cursor-pointer">→</span>
                    </h5>
                </div>
            </div>
        {/if}
        {#if index === 3}
            <div in:fly={{duration:500,delay:500,x:300}} out:fly={{duration:500,delay:0,x:-300}} class="grid grid-cols-12 project-3">
                <div class="lg:col-span-4 col-span-12 h-full text-left flex flex-col justify-center order-1 lg:order-none">
                    <a target="_blank" class="text-4xl lg:text-5xl project-title py-4 lg:pb-10 lg:pt-0" href="blog.tokenomy.com/">Tokenomy</a>
                    <p class="project-description lg:text-base text-sm pb-8">Working from a design spec, I built a dynamic, multi-language, fully custom Wordpress website for Tokenomy. Elementor was used to speed up production, while custom loop templates, user permissions, and other features we're added by client request. </p>
                    <div class="tags-container"><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">WordPress</span><span class="bg-black text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300 mt-6" style="width:fit-content">Elementor</span></div>
                </div>
                <div class="lg:col-span-8 col-span-12 flex flex-col lg:content-end content-center flex-wrap img-container items-end md:items-center mb-12 lg:mb-0">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/Tokenomy-laptop-port.png">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/TokenomyFinal2.png" style="display: none;">
                    <img class="project-img mb-4 w-full lg:w-4/5" src="images/TokenomyFinal3.png" style="display: none;">
                    <h5 class="text-2xl font-thin w-full text-center img-navigation">
                        <span on:click={prevImage} class="cursor-pointer">←</span> | 
                        <span on:click={nextImage} class="cursor-pointer">→</span>
                    </h5>
                </div>
            </div>
        {/if}
    </div>
    <div class="shrink-0 grow-0 basis-1/12 px-4 grid grid-cols-12">
        <div class="col-span-6 h-full text-left md:pr-10">
            <h5 on:click={handlePrevProject} class="prev-proj text-lg lg:text-2xl font-thin cursor-pointer hover:underline">← Previous Project</h5>
        </div>
        <div class="col-span-6 flex flex-row justify-end md:pl-10">
            <h5 on:click={handleNextProject} class="next-proj text-lg lg:text-2xl font-thin cursor-pointer hover:underline">Next Project →</h5>
        </div>
    </div>
</div>

<style>
    .img-container {
        position: relative;
        height: 180px;
    }
    .project-img {
        position: absolute;
        top: 50%;
        left: 50%;
        height: 100%;
        object-fit: cover;
        transform: translate(-50%, -50%);
    }
    .img-navigation {
        position: relative;
        z-index: 1; /* Ensure the navigation is above the images */
        top: calc(100% + 1rem);
    }
    @media (min-width: 768px) {
        .img-container {
            height: 400px;
        }
    }
</style>